<template>
  
    <v-container>
        <v-btn fab dark color="indigo" v-on:click="openAddUser" style="position: relative; float:right;">
          <v-icon dark>add</v-icon>
        </v-btn>
        <v-data-table
            v-bind:headers="headers"
            :items="users"
            hide-actions
            class="elevation-1"
            >
                <template slot="items" scope="props">
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.email }}</td>
                <td>{{ props.item.phone }}</td>
                <td><v-select v-bind:items="roles" item-text="text" item-value="value" v-model="props.item.role" label="Select" single-line bottom v-on:change="changeRole(props.item, $event)"></v-select></td>
            </template>
        </v-data-table>
        <add-user-modal :open="addUserOpen" :close="closeAddUser"></add-user-modal>
    </v-container>
</template>

<script>
import AddUserModal from '@/components/AddUserModal';

export default {
  name: 'user-overview',
  mounted() {
    this.$store.dispatch('RETRIEVE_USERS');
  },
  data() {
      return {
          roles: [
            {text: 'Geblokkeerd', value: 0},
            {text: 'Gebruiker', value: 10},
            {text: 'Administrator', value: 99},
          ],
          headers: [
              {text: 'Naam', align: 'left', sortable: false},
              {text: 'Email', align: 'left', sortable: false},
              {text: 'Telefoon', align: 'left', sortable: false},
              {text: 'Rol', align: 'left', sortable: false},
          ],
          addUserOpen: false
      }
  },
  computed: {
    users() {
      return this.$store.getters.users;
    }
  },
  methods: {
    changeRole(user, newRole) {
      this.$store.dispatch('CHANGE_USER_ROLE', {id: user.id, role: newRole});
    },
    openAddUser() {
      this.addUserOpen = true;
    },
    closeAddUser() {
      this.addUserOpen = false;
    }
  },
  components: {
      AddUserModal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserOverview.vue